// extracted by mini-css-extract-plugin
export default {"header":"LayoutHeader_header__6-gDB","logo":"LayoutHeader_logo__9GDIU","title":"LayoutHeader_title__LSRI3"};